import React, { useContext, useEffect } from 'react'

//components
import ContentWithProducts from './components/ContentWithProducts'
import ContentWithCampaign from './components/ContentWithCampaign'
import Layout from 'components/layout/Games'
import SlideLayout from 'components/layout/Games/Slide'
//contexts
import AuthContext from 'context/AuthContext'
import LoaderContext from 'context/LoaderContext'
//constants
import { LOCAL_STORAGE } from 'constants/index'
//hooks
import useQueryTremendousCampaign from './_hooks/useQueryTremendousCampaign'
import useQueryGiftCards from './_hooks/useQueryGiftCards'
//utils
import { handleHeaderDecrementCounter } from 'utils/animations'

const PREV_ROUTES = ['/library', '/games', '/quests']

const GiftCardsList = () => {
  const { user } = useContext(AuthContext)
  const { isLoading, showLoader, hideLoader } = useContext(LoaderContext)

  const { giftCards, isLoadingGiftCards } = useQueryGiftCards()
  const { campaign, timeLimit, isLoadingTremendousCampaign } =
    useQueryTremendousCampaign('non_us_playback')

  useEffect(() => {
    if (isLoadingGiftCards || isLoadingTremendousCampaign) {
      showLoader()
      return
    }
    hideLoader()

    const stringifiedPreviousBalance = localStorage.getItem(
      LOCAL_STORAGE.BALANCE_BEFORE_GIFT_CARD_REDEMPTION
    )
    if (stringifiedPreviousBalance) {
      const previousBalance = JSON.parse(stringifiedPreviousBalance)

      handleHeaderDecrementCounter(false, previousBalance.coins, user?.points)
      handleHeaderDecrementCounter(true, previousBalance.piggyBanks, user?.piggyBanks)
      localStorage.removeItem(LOCAL_STORAGE.BALANCE_BEFORE_GIFT_CARD_REDEMPTION)
    }
  }, [isLoadingGiftCards, isLoadingTremendousCampaign])

  return (
    <Layout isLoading={isLoading}>
      <SlideLayout
        prevRoutes={PREV_ROUTES}
        swipeIn={!isLoadingGiftCards && !isLoadingTremendousCampaign}
        isSwiping={false}
      >
        {user?.country === 'United States' ? (
          <ContentWithProducts giftCards={giftCards} />
        ) : (
          <ContentWithCampaign campaign={campaign} timeLimit={timeLimit} />
        )}
      </SlideLayout>
    </Layout>
  )
}

export default GiftCardsList
